// src/components/resources/tools/generators/SubtitleOverlay/template-processor.ts
//
// Pure template-placeholder processor harvested from <SubtitleOverlayOutput>.
// The former in-component `processTemplate` closed over `formData`; here it takes
// it as an explicit argument so the substitution logic is unit-testable in
// isolation. Logic is a verbatim move.
import { safeString } from '~/lib/utils/formatters'

/**
 * Replaces template placeholders (e.g., {{key}}) in a string with corresponding values from formData.
 * Also supports special template functions such as {{formatDate now "YYYY-MM-DD"}}.
 */
export function processTemplate(template: string, formData: Record<string, unknown>): string {
  let result = template

  // Replace all {{key}} placeholders with their safe string values from formData
  for (const [key, value] of Object.entries(formData)) {
    const placeholder = `{{${key}}}`
    const safeValue = safeString(value)
    result = result.replace(new RegExp(placeholder, 'g'), safeValue)
  }

  // Replace special date formatting placeholders
  result = result.replace(/\{\{formatDate\s+now\s+"([^"]+)"\}\}/g, (_, format: string): string => {
    const now = new Date()
    if (format === 'YYYY-MM-DD') {
      // Return date in ISO format (YYYY-MM-DD)
      return now.toISOString().split('T')[0] ?? ''
    }
    // Fallback to locale date string
    return now.toLocaleDateString('en-US') ?? ''
  })

  return result
}
